<template>
  <q-card flat bordered class="q-pa-md">
    <div :class="$q.dark.mode ? '' : 'text-primary '">
      <span class="text-subtitle1 text-bold">Weekly Signals</span>
    </div>

    <PackageAuth>
      <template #authorized-content>
        <q-card flat bordered>
          <q-tabs
            v-model="tab"
            dense
            inweak-label
            outside-arrows
            mobile-arrows
            :class="$q.dark.mode ? 'bg-grey-10' : 'text-grey-9 bg-grey-4'"
            active-color="white"
            :active-bg-color="$q.dark.mode ? 'grey-9' : 'blue-4'"
            :indicator-color="$q.dark.mode ? 'grey-7' : 'blue-5'"
            align="justify"
            narrow-indicator
          >
            <q-tab name="buySignal" label="Green Signal" no-caps />
            <q-tab name="sellSignal" label="Red Signal" no-caps />
          </q-tabs>

          <q-separator></q-separator>

          <q-tab-panels class="q-mt-xs" v-model="tab" animated>
            <q-tab-panel class="q-pa-none" name="buySignal">
              <div class="row">
                <div class="col-md-4 col-sm-12 col-12">
                  <q-card flat bordered class="q-mb-sm q-pa-sm">
                    <div class="q-gutter-sm q-mt-x q-pa-sm">
                      <p
                        class="q-my-none text-bold text-subtitle1 text-secondary"
                      >
                        Signal Strength
                      </p>
                      <q-radio
                        keep-color
                        dense
                        color="teal"
                        v-model="signalStrength"
                        val="all"
                        label="All "
                      />
                      <q-radio
                        keep-color
                        dense
                        color="teal"
                        v-model="signalStrength"
                        val="weak_signal"
                        label="Weak "
                      />
                      <q-radio
                        keep-color
                        dense
                        color="teal"
                        v-model="signalStrength"
                        val="medium_signal"
                        label="Medium "
                      />
                      <q-radio
                        keep-color
                        dense
                        color="teal"
                        v-model="signalStrength"
                        val="strong_signal"
                        label="Strong "
                      />
                    </div>
                  </q-card>

                  <ListCard
                    class="q-mb-md"
                    :name="'Green Signal'"
                    cv
                    :data="buyWeeklyDataComputed"
                    :noHeader="true"
                    :weekly="true"
                    :type="'buy_confirm'"
                    :loading="loading"
                    :activeSymbol="symbolConfirmBuy"
                    @clickSymbol="
                      (eSymbol) => {
                        symbol = eSymbol;
                        symbolConfirmBuy = eSymbol;
                      }
                    "
                  />

                  <StockWiseSignalStatusCustom
                    :symbol="symbol"
                    :daily="true"
                    @buysellData="
                      (eventData) => {
                        emitBuySellData = eventData;
                      }
                    "
                  />

                  <keyValueAlertStockWise class="q-mt-xs" :symbol="symbol" />
                  <q-card>
                    <DisclaimerMessage class="q-mt-xs" short />
                  </q-card>
                </div>
                <div class="col-md-8 q-pl-md-md col-sm-12 col-12">
                  <TradingViewMini
                    :symbol="symbol"
                    :enableDailyWeeklyIntraday="true"
                    :isSignalType="true"
                    :signalTypedata="emitBuySellData"
                  />
                  <div class="q-mt-md">
                    <StockWiseChukulPerformance
                      v-if="symbol"
                      class="q-mt-xl"
                      :searchStock="symbol"
                      :key="symbol"
                    />
                  </div>
                  <ConfirmSignal class="q-mt-md" :symbol="symbol" />
                </div>
              </div>
            </q-tab-panel>

            <q-tab-panel class="q-pa-none" name="sellSignal">
              <div class="row">
                <div class="col-md-4 col-sm-12 col-12">
                  <ListCard
                    class="q-mb-md"
                    :name="'Red Signal'"
                    :data="sellWeeklyDataComputed"
                    :noHeader="true"
                    :weekly="true"
                    :type="'sell_confirm'"
                    :loading="loading"
                    :activeSymbol="symbolConfirmSell"
                    @clickSymbol="
                      (eSymbol) => {
                        symbol = eSymbol;
                        symbolConfirmSell = eSymbol;
                      }
                    "
                  />
                  <StockWiseSignalStatusCustom
                    class="q-my-sm"
                    :symbol="symbol"
                    :daily="true"
                    @buysellData="
                      (eventData) => {
                        emitBuySellData = eventData;
                      }
                    "
                  />

                  <keyValueAlertStockWise
                    v-if="symbol"
                    class="q-my-sm"
                    :symbol="symbol"
                  />
                  <q-card>
                    <DisclaimerMessage class="q-mt-xs" short />
                  </q-card>
                </div>
                <div class="col-md-8 q-pl-md-md col-sm-12 col-12">
                  <TradingViewMini
                    :symbol="symbol"
                    :enableDailyWeeklyIntraday="true"
                  />
                  <StockWiseChukulPerformance
                    v-if="symbol"
                    class="q-mt-md"
                    :searchStock="symbol"
                    :key="symbol"
                  />
                  <ConfirmSignal class="q-mt-md" :symbol="symbol" />
                </div>
              </div>
            </q-tab-panel>
          </q-tab-panels>
        </q-card>
      </template>
    </PackageAuth>
  </q-card>
</template>

<script setup>
import { ref, watch, onMounted, computed } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";

import useData from "src/use/data";
import useMembership from "src/use/membership";

import ConfirmSignal from "src/components/signalTable/ConfirmSignal.vue";
import ListCard from "src/components/ListCard.vue";
import TradingViewMini from "src/components/Tradingview/TradingViewMini.vue";
import DisclaimerMessage from "src/components/DisclaimerMessage.vue";
import StockWiseSignalStatusCustom from "src/components/StockWiseSignalStatusCustom.vue";
import StockWiseChukulPerformance from "src/components/StockWiseChukulPerformance.vue";
import keyValueAlertStockWise from "src/components/KeyValue/keyValueAlertStockWise.vue";
import { useQuasar } from "quasar";
import PackageAuth from "src/components/Packages/PackageAuth.vue";

const props = defineProps({
  symbol: {
    type: String,
  },
});

const $route = useRoute();
const store = useStore();
const $q = useQuasar();

const { buySellSearch } = useData();
const { getPackageStatus } = useMembership();
const packageDetail = ref({});

const tab = ref(null);

const buyWeeklyData = ref([]);
const sellWeeklyData = ref([]);

const buySellWeeklyData = ref([]);
const emitBuySellData = ref({});

const loading = ref(true);

const symbol = ref(null);
const symbolConfirmBuy = ref(null);
const symbolConfirmSell = ref(null);
const signalStrength = ref("all");

tab.value = $route.query?.signal || "buySignal";

if (store.state.authenticate.isAuthenticated) {
  getPackageStatus()
    .then((res) => {
      packageDetail.value = res.data;
      loading.value = false;
    })
    .catch((err) => {
      packageDetail.value = null;
    });
}

const filterForListCard = (signalData, signalType) => {
  const filterKey = signalType === "buy" ? "buy_date" : "sell_date";
  let d =  signalData
    .slice()
    .map((item) => {
      return {
        symbol: item.symbol,
        date: item[filterKey],
        weak_signal: item.weak_signal,
        medium_signal: item.medium_signal,
        strong_signal: item.strong_signal,
        very_strong_signal: item.very_strong_signal,
      };
    })
    .map((entry) => {
      const {
        weak_signal,
        medium_signal,
        strong_signal,
        very_strong_signal,
        ...rest
      } = entry;

      if (weak_signal === "Y") {
        return { ...entry, signal_strength: "weak_signal" };
      } else if (medium_signal === "Y") {
        return { ...entry, signal_strength: "medium_signal" };
      } else if (strong_signal === "Y") {
        return { ...entry, signal_strength: "strong_signal" };
      } else if (very_strong_signal === "Y") {
        return { ...entry, signal_strength: "very_strong_signal" };
      } else {
        return entry;
      }
    })
    .filter((item) => {
      return (
        item.date
      );
    })
    .sort((a, b) => {
      return new Date(b.date) - new Date(a.date);
    });
    return d ? [d[0]] : [];
};

const loadData = (symbol) => {
  buySellSearch(symbol)
    .then((res) => {
      buySellWeeklyData.value = res.data;
      sellWeeklyData.value = filterForListCard(
        buySellWeeklyData.value.slice(),
        "sell"
      );
      buyWeeklyData.value = filterForListCard(
        buySellWeeklyData.value.slice(),
        "buy"
      );

      symbolConfirmSell.value = sellWeeklyData.value?.[0]?.symbol || null;
      symbolConfirmBuy.value = buyWeeklyData.value?.[0]?.symbol || null;

      loading.value = false;
    })
    .catch((error) => {
      console.log(error);
    });
};

const buyWeeklyDataComputed = computed(() => {
  const isAllSignalStrength = signalStrength.value === "all";

  return buyWeeklyData.value.filter((item) => {
    const isSignalStrengthMatch =
      isAllSignalStrength || item.signal_strength === signalStrength.value;

    return isSignalStrengthMatch;
  });
});

const sellWeeklyDataComputed = computed(() => {
  return sellWeeklyData.value;
});

watch(tab, (newTab, oldTab) => {
  if (newTab !== oldTab) {
    if (newTab === "buySignal") {
      symbol.value = symbolConfirmBuy.value;
    } else {
      symbol.value = symbolConfirmSell.value;
    }
  }
});

watch(
  () => props.symbol,
  (newVal, oldVal) => {
    loadData(newVal);
  }
);

onMounted(async () => {
  loadData(props.symbol);
});
</script>
